import { Slide } from "@jelly/lesson";

import { task as task03 } from "../../../../../task/course-03/lesson-08/task-03";

const task: Slide = {
  titleHtml:
    "How is the point in time determined at which an audible image source is inserted in</br>the room impulse response?",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task03.id,
        },
      },
    },
  },
};

export default task;
